import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ErrorPage from '../not_found/NotFound';
import CustomButton from "../ui/Button";
import { BrowseLibraryServices } from "../api/BrowserLibrary";
import Loader from "../ui/Loader";
import { useTranslation } from "react-i18next";


const BrowseLibrary = () => {
  const { t } = useTranslation("library");
  const [libraryDetails, setLibraryDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLibraryDetails = async () => {
      try {
        const response = await BrowseLibraryServices();
        // Check if the response has a data field
        if (response.data) {
          setLibraryDetails(response.data);
        }
        setLoading(false);
      } catch (err) {

        console.error("Error fetching library details:", err);
        setError(
          <ErrorPage
            title={t("library_not_found")}
            description={t("library_error_message")}
          />
        );
        setLoading(false);
      }
    };

    fetchLibraryDetails();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="max-w-screen-xl mx-auto px-4 md:px-8 py-0">
      <img
        src="/assets/servicesbg.svg"
        className="absolute inset-0 w-full h-full object-cover -z-[1000]"
        alt="background animation"
      />
      <div className="absolute inset-0 bg-[#00000099] -z-[1000]"></div>
      <div className="mx-4 md:mx-0">
        <h2 className="web-heading-main text-white mb-6 mt-12">{t("all_library")}</h2>
        <p className="body-xl text-[#F0F0F0] mb-8">
          {t("all_library_description")}
        </p>
      </div>
      <div className="mt-[56px] grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-6">
        {libraryDetails.map((library, index) => (
          <Link key={index} to={`/library/library-detail/${library.slug}`}>
            <div
              className="relative shadow-md rounded overflow-hidden min-h-[150px] mx-4 sm:mx-0 bg-[#FFFFFF33] flex flex-col justify-between"
            >
              <div className="p-6">
                <div className="max-w-[445px]">
                  <p className="web-heading-main-7">
                    {library.company_name}
                  </p>
                  <h2 className="body-medium-2 mb-2 mt-[16px] truncate">
                    {library.description}
                  </h2>
                </div>
              </div>
              <button className="absolute bottom-4 right-4 rounded-lg">
                <img src="/assets/link-flat.svg" alt="Link Icon" />
              </button>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BrowseLibrary;
